<template>
  <div class="box box_v">
    <!--头部-->
    <page-head
      title="重点人员排查信息"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    >
    </page-head>
    <div class="content">
      <div class="box_f1 box_v wrapper">
        <Modal
          class="reset-modal"
          title="导入结果"
          v-model="resultModal"
          width="660px"
          :footer-hide="true"
        >
          <div>{{ resContent }}</div>
        </Modal>
        <Modal
          v-model="importModal"
          title="导入重点人员排查信息"
          width="660px"
          height="400px"
          :footer-hide="true"
          @on-cancel="closeModel"
        >
          <!--/assets/企业导入模板.xlsx-->
          <div class="note box">
            请上传符合模板要求的重点人员排查信息文件,支持.xlsx格式
            <a
              class="download"
              href="https://py.shequyun.cn/base/mongofile/default/601a1cb5747f3b0001ac8230.xlsx"
              download="重点人员排查信息模板"
              >下载模板</a
            >
          </div>
          <Upload
            ref="upload"
            :show-upload-list="false"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :headers="header"
            :action="actionuri"
            :on-success="handleSuccess"
            :on-progress="handleProgress"
            :on-error="handleError"
          >
            <Button :loading="uploadLoading" class="mt-2" type="primary"
              >导入数据</Button
            >
          </Upload>
        </Modal>
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="所属区域">
                <Cascader
                  v-model="comList"
                  :data="communityList"
                  placeholder="请选择"
                  clearable
                  @on-change="communityChange"
                  change-on-select
                ></Cascader>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="批次" prop="batchNO">
                <Input
                  v-model="query.batchNO"
                  clearable
                  placeholder="请输入批次"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="运营商" prop="carrier">
                <Select v-model="query.carrier" clearable>
                  <Option
                    v-for="item in carrierList"
                    :key="item.type"
                    :value="item.type"
                    :label="item.name"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="姓名" prop="userName">
                <Input
                  v-model="query.userName"
                  clearable
                  placeholder="请输入姓名"
                />
              </form-item>
            </i-col>

            <i-col span="6">
              <form-item label="手机号" prop="phoneNO">
                <Input
                  v-model="query.phoneNO"
                  clearable
                  placeholder="请输入手机号"
                />
              </form-item>
            </i-col>

            <i-col span="6">
              <form-item label="证件号码" prop="idCardNO">
                <Input
                  v-model="query.idCardNO"
                  clearable
                  placeholder="请输入证件号码"
                />
              </form-item>
            </i-col>

            <i-col span="6">
              <form-item label="离濮时间" prop="time">
                <DatePicker
                  v-model="leaveTime"
                  class="time"
                  placeholder="请选择离濮时间"
                ></DatePicker>
              </form-item>
            </i-col>

            <i-col span="6">
              <form-item label="返濮时间" prop="time1">
                <DatePicker
                  v-model="returnTime"
                  class="time"
                  placeholder="请选择返濮时间"
                ></DatePicker>
              </form-item>
            </i-col>

            <i-col span="6">
              <form-item label="外出地" prop="leaveAddress">
                <!-- <Cascader
                  v-model="fromWhereList"
                  :data="areadata"
                  :load-data="getArea"
                  placeholder="请选择"
                  clearable
                  @on-change="fromWhereChange"
                  change-on-select
                ></Cascader> -->
                <Input
                  v-model="query.leaveAddress"
                  clearable
                  placeholder="请输入外出地"
                />
              </form-item>
            </i-col>

            <i-col span="6">
              <form-item label="是否在濮" prop="isHere">
                <Select v-model="query.isHere" clearable>
                  <Option
                    v-for="item in dicList"
                    :key="item.type"
                    :value="item.type"
                    :label="item.name"
                  ></Option>
                </Select>
              </form-item>
            </i-col>

            <i-col span="6">
              <form-item label="是否隔离" prop="isQuarantine">
                <Select v-model="query.isQuarantine" clearable>
                  <Option
                    v-for="item in dicList"
                    :key="item.type"
                    :value="item.type"
                    :label="item.name"
                  ></Option>
                </Select>
              </form-item>
            </i-col>

            <i-col span="6">
              <form-item label="隔离地点" prop="quarantineAddress">
                <Input
                  v-model="query.quarantineAddress"
                  clearable
                  placeholder="请输入隔离地点"
                />
              </form-item>
            </i-col>
            
            <i-col span="6">
              <form-item label="目前所在地" prop="currentAddress">
                <Input
                  v-model="query.currentAddress"
                  clearable
                  placeholder="请输入目前所在地"
                />
              </form-item>
            </i-col>

            <i-col span="6">
              <form-item label="隔离方式" prop="quarantineType">
                <Input
                  v-model="query.quarantineType"
                  clearable
                  placeholder="请输入隔离方式"
                />
              </form-item>
            </i-col>

            <i-col span="6">
              <form-item label="是否核酸检测" prop="isCheck">
                <Select v-model="query.isCheck" clearable>
                  <Option
                    v-for="item in dicList"
                    :key="item.type"
                    :value="item.type"
                    :label="item.name"
                  ></Option>
                </Select>
              </form-item>
            </i-col>

            <i-col span="6">
              <form-item label="检测结果" prop="checkResult">
                <Select v-model="query.checkResult" clearable>
                  <Option
                    v-for="item in resultList"
                    :key="item.type"
                    :value="item.type"
                    :label="item.name"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
          </row>
        </i-form>
      </div>
    </div>

    <div class="content">
      <div class="box_f1 box_v">
        <div class="table-data">
          <i-table
            :columns="tableHeader"
            :border="true"
            :data="tableData"
            :loading="isLoading"
            stripe
            ref="table"
            @on-row-dblclick="handleClickDetail"
          >
            <template slot-scope="{ row, index }" slot="action">
              <span @click="handleClickDetail(row)" class="action">[详情]</span>
            </template>
          </i-table>
          <div class="page">
            <page
              :total="total"
              :current="pageNum"
              @on-change="pageChange"
              show-total
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import selectCommunity from "../../../components/selectCommunity";
import api from "../../../api/index";

const {
  getPersonInspectionList,
  importPersonInspection,
  exportPersonInspection,
} = api;
const LOCATIONMAP = {
  0: {
    isHere: "否",
  },
  1: {
    isHere: "是",
  },
};
const ISOLATIONMAP = {
  0: {
    isQuarantine: "否",
  },
  1: {
    isQuarantine: "是",
  },
};
const CHECKMAP = {
  0: {
    isCheck: "否",
  },
  1: {
    isCheck: "是",
  },
};
const RESULTMAP = {
  0: {
    checkResult: "阴性",
  },
  1: {
    checkResult: "阳性",
  },
  2: {
    checkResult: "未出结果",
  },
};
const CARRIERMAP = {
  0: {
    carrier: "其他",
  },
  1: {
    carrier: "移动",
  },
  2: {
    carrier: "联通",
  },
  3: {
    carrier: "电信",
  },
};
export default {
  name: "personInspection",
  components: {
    pageHead,
    selectCommunity,
  },
  data() {
    return {
      query: {
        communityId: "",
        batchNO: "",
        carrier: "",
        userName: "",
        idCardNO: "",
        phoneNO: "",
        leaveTime: "",
        returnTime: "",
        leaveAddress: "",
        isHere: "",
        isQuarantine: "",
        quarantineAddress: "",
        quarantineType: "",
        isCheck: "",
        checkResult: "",
      },
      pageNum: 1,
      pageSize: 10,
      total: 0,
      leaveTime: "",
      returnTime: "",
      actionuri: importPersonInspection,
      uploadLoading: false,
      importModal: false,
      resultModal: false,
      isLoading: false,
      resContent: "",
      comList: [],
      fromWhereList: [],
      communityList: [], // 当前行政区域
      areadata: [], //全国行政区域
      dicList: [
        {
          name: "是",
          type: 1,
        },
        {
          name: "否",
          type: 0,
        },
      ],
      carrierList: [
        {
          name: "移动",
          type: 1,
        },
        {
          name: "联通",
          type: 2,
        },
        {
          name: "电信",
          type: 3,
        },
        {
          name: "其他",
          type: 0,
        },
      ],
      resultList: [
        {
          name: "阳性",
          type: 1,
        },
        {
          name: "阴性",
          type: 0,
        },
        {
          name: "未出结果",
          type: 2,
        },
      ],
      btnList: [
        {
          name: "导入",
          type: "import",
          loading: false,
        },
        {
          name: "导出",
          type: "export",
          loading: false,
        },
        {
          name: "重置",
          type: "reset",
          loading: false,
        },
        {
          name: "搜索",
          type: "search",
          loading: false,
        },
      ],
      tableHeader: [],
      tableData: [],
      header: {
        token: window.sessionStorage.getItem("token"),
      },
    };
  },
  computed: {
    isJiedao() {
      return parseInt(this.$store.state.isJiedao);
    },
  },
  watch: {},
  methods: {
    handleBtn(type) {
      if (type == "import") {
        this.importModal = true;
      } else if (type == "export") {
        this.export();
      } else if (type == "reset") {
        this.reset();
      } else if (type == "search") {
        console.log("search");
        this.getPersonInspectionList();
      }
    },
    export() {
      console.log("export");
      let {
        communityId,
        batchNO,
        carrier,
        userName,
        idCardNO,
        phoneNO,
        leaveTime,
        returnTime,
        leaveAddress,
        isHere,
        isQuarantine,
        quarantineAddress,
        quarantineType,
        isCheck,
        checkResult,
      } = this.query;
      console.log("communityId", communityId);
      console.log("userName", userName);
      console.log("idCardNO", idCardNO);
      console.log("phoneNO", phoneNO);
      console.log("leaveTime", leaveTime);
      console.log("returnTime", returnTime);
      console.log("leaveAddress", leaveAddress);
      console.log("isHere", isHere);
      console.log("isQuarantine", isQuarantine);
      console.log("quarantineAddress", quarantineAddress);
      console.log("quarantineType", quarantineType);
      console.log("isCheck", isCheck);
      console.log("checkResult", checkResult);

      let url =
        exportPersonInspection +
        "?batchNO=" + 
        batchNO +
        "&carrier=" + 
        carrier + 
        "&userName=" +
        userName +
        "&communityId=" +
        communityId +
        "&idCardNO=" +
        idCardNO +
        "&phoneNO=" +
        phoneNO +
        "&leaveTime=" +
        leaveTime +
        "&returnTime=" +
        returnTime +
        "&leaveAddress=" +
        leaveAddress +
        "&isHere=" +
        isHere +
        "&isQuarantine=" +
        isQuarantine +
        "&quarantineAddress=" +
        quarantineAddress +
        "&quarantineType=" +
        quarantineType +
        "&isCheck=" +
        isCheck +
        "&checkResult=" +
        checkResult +
        "&token=" +
        this.header.token;
      console.log(url);
      window.open(url);
    },
    reset() {
      console.log("reset");
      this.pageNum = 1;
      this.query.communityId = this.$store.state.streetorcommunityid;
      this.leaveTime = "";
      this.returnTime = "";
      this.fromWhereList = [];
      this.comList = [];
      this.$refs.search.resetFields();
    },
    async getPersonInspectionList() {
      this.isLoading = true;
      try {
        this.query.leaveTime = this.leaveTime
          ? this.$util.FormatDate(new Date(this.leaveTime), "yyyy-MM-dd")
          : "";
        this.query.returnTime = this.returnTime
          ? this.$util.FormatDate(new Date(this.returnTime), "yyyy-MM-dd")
          : "";

        let res = await this.$post(getPersonInspectionList, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.query,
        });
        console.log(this.query);

        let list = res.rows.map((item) => ({
          ...item,
          ...LOCATIONMAP[item.isHere],
          ...ISOLATIONMAP[item.isQuarantine],
          ...CHECKMAP[item.isCheck],
          ...RESULTMAP[item.checkResult],
          ...CARRIERMAP[item.carrier],
        }));
        console.log(list);
        this.tableData = list;
        this.total = res.total;
      } finally {
        this.isLoading = false;
      }
    },
    //获取行政区域
    getArea(item, callback) {
      item.loading = true;
      this.$post(this.urlobj.getArea + "id=" + item.id)
        .then((res) => {
          let data = res.map((_item) => {
            let resturn_data = {
              pid: _item.pid,
              id: _item.id,
              value: _item.path,
              label: _item.text,
              level: item.level + 1,
            };
            if (item.level != 2) {
              resturn_data.children = [];
              resturn_data.loading = false;
            }

            return resturn_data;
          });
          if (item.level == 0) {
            this.areadata = data;
          } else {
            item.loading = false;
            item.children = data;
            callback();
          }
        })
        .catch((e) => {
          this.$Message.error("获取行政区域失败");
        });
    },
    fromWhereChange(value) {
      this.query.leaveAddress = value[value.length - 1];
      //   console.log(this.query.leaveAddress)
      //   this.initFangyiList();
    },
    communityChange(value) {
      this.query.communityId = value[value.length - 1];
      console.log(this.query.communityId);
    },
    getCommunity() {
      this.$get(this.urlobj.getCommunityCascade, {
        communityId: this.$store.state.streetorcommunityid,
        nationwide: 1,
        lowestLevelId: 10000007770009,
      })
        .then((res) => {
          this.communityList = res.rows.length
            ? this.formateData(res.rows)
            : [];
          console.log(this.communityList);
        })
        .catch((e) => {
          this.$Message.error("获取行政区域失败");
        });
    },
    formateData(data) {
      let returnData = data.map((item) => {
        return {
          value: item.communityId,
          label: item.communityName,
          children: item.children.length ? this.formateData(item.children) : [],
        };
      });
      return returnData;
    },
    closeModel(data) {
      this.importModal = false;
    },
    handleProgress() {
      this.uploadLoading = true;
    },
    handleSuccess(e) {
      console.log(e);
      this.uploadLoading = false;
      this.importModal = false;
      if (e.isSucceed) {
        this.resContent = e.message;
        this.resultModal = true;
        // this.$Message.success(e.message);
        this.pageNum = 1;
        this.getPersonInspectionList();
      } else {
        this.$Message.error(e.message);
      }
    },
    handleError(e) {
      console.log(e);
      this.uploadLoading = false;
      this.importModal = false;
      this.$Message.error("导入失败");
    },
    pageChange(val) {
      this.pageNum = val;
      this.getPersonInspectionList();
    },
    handleClickDetail(item) {
      console.log(item);
      this.$router.push({
        name: "personInspectionDetail",
        query: { id: item.id },
      });
    },
    initHeader() {
      this.tableHeader = [
        {
          title: "序号",
          type: "index",
          fixed: "left",
          width: 80,
        },
        {
          title: "所属区域",
          key: "communityName",
          width: 220,
        },
        {
          title: "批次",
          key: "batchNO",
          width: 120,
        },
        {
          title: "运营商",
          key: "carrier",
          width: 80,
        },
        {
          title: "姓名",
          key: "userName",
          width: 80,
        },
        {
          title: "手机号",
          key: "phoneNO",
          width: 180,
        },
        {
          title: "证件号码",
          key: "idCardNO",
          width: 180,
        },
        {
          title: "离濮时间",
          key: "leaveTime",
          width: 180,
        },
        {
          title: "返濮时间",
          key: "returnTime",
          width: 180,
        },
        {
          title: "外出地",
          key: "leaveAddress",
          width: 180,
        },
        {
          title: "是否在濮",
          key: "isHere",
          width: 120,
        },
        {
          title: "目前所在地",
          key: "currentAddress",
          width: 120,
        },
        {
          title: "是否隔离",
          key: "isQuarantine",
          width: 120,
        },
        {
          title: "隔离地点",
          key: "quarantineAddress",
          width: 180,
        },
        {
          title: "隔离方式",
          key: "quarantineType",
          width: 180,
        },
        {
          title: "是否核酸检测",
          key: "isCheck",
          width: 130,
        },
        // {
        //   title: "最后一次核酸检测时间",
        //   key: "lastCheckTime",
        //   width: 130,
        // },

        {
          title: "检测结果",
          key: "checkResult",
          width: 130,
        },
        {
          title: "操作",
          width: 160,
          slot: "action",
        },
      ];
    },
  },

  created() {
    // this.getArea({ id: "100000000000", level: 0 });
    this.getCommunity();
    this.initHeader();
    this.getPersonInspectionList();
  },
  mounted() {},
};
</script>

<style scoped lang="less">
.content {
  margin: 0 20px;
}

.time {
  width: 100%;
}

.wrapper {
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}

.mt-2 {
  margin-top: 20px;
}

.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 600px);
  margin-bottom: 10px;
  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .action {
    color: #5e6d94;
    cursor: pointer;
    margin-right: 10px;
  }
}
</style>
